/**
 * Centralized body / document scroll lock for overlays (mobile nav, modals).
 * Use forceUnlockDocumentScroll() on route changes and after closing overlays
 * so no route leaves the app with overflow:hidden on body.
 */

export function lockBodyScrollMobileNav() {
  if (typeof document === 'undefined') return;
  const scrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'relative';
  document.body.setAttribute('data-scroll-y', String(scrollY));
}

export function unlockBodyScrollMobileNav() {
  if (typeof document === 'undefined') return;
  const scrollY = document.body.getAttribute('data-scroll-y');
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.removeAttribute('data-scroll-y');
  if (scrollY) {
    requestAnimationFrame(() => {
      window.scrollTo(0, parseInt(scrollY || '0', 10));
    });
  }
}

/**
 * Aggressive unlock: clears inline overflow/position on body and html.
 * Call on every route change and when defensively recovering from stuck scroll.
 */
export function forceUnlockDocumentScroll() {
  if (typeof document === 'undefined') return;
  // An open modal dialog owns the scroll lock; the defensive unlocks that run on mount / route
  // change (often on the next animation frame) must not release it from underneath the dialog.
  if (document.querySelector('[role="dialog"][aria-modal="true"]')) return;

  const body = document.body;
  const html = document.documentElement;

  body.style.overflow = '';
  body.style.overflowY = '';
  body.style.removeProperty('overflow-y');
  body.style.position = '';
  body.style.top = '';
  body.style.width = '';
  body.style.touchAction = '';
  body.removeAttribute('data-scroll-y');

  html.style.overflow = '';
  html.style.overflowY = '';
  html.style.removeProperty('overflow-y');
  html.style.touchAction = '';
}
